import React, { useContext, useMemo } from "react";

import { StoryQuestion as Prompt } from "chq";

import { getTrend, t } from "app/utils";

import StoryQuestion from "components/stories/StoryQuestion";
import { StoryModalContext } from "components/stories/video-studio/contexts/StoryContext";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";


interface PromptSelectorProps {
  fetching: boolean;
  storyQuestions: Prompt[];
}

const PromptSelector: React.FC<PromptSelectorProps> = ({ fetching, storyQuestions }) => {
  const { isControlledModeStories } = useContext(StoryModalContext);
  const { data: { storyQuestionId }, handleUpdateData } = useContext(CreatomateContext);

  const storyQuestion = useMemo(
    () => (!isControlledModeStories
    && storyQuestionId
    && Array.isArray(storyQuestions)
    && storyQuestions.find(({ id }) => id === storyQuestionId)) || undefined,
    [isControlledModeStories, storyQuestionId, storyQuestions]
  );


  const handleOnSelectQuestion = (selectedQuestion?: Prompt | number) => {
    if (!selectedQuestion) return;

    if (typeof selectedQuestion === "number" || typeof selectedQuestion === "string") {
      handleUpdateData({ storyQuestionId: selectedQuestion });
    } else {
      handleUpdateData({ storyQuestionId: selectedQuestion.id, trend: getTrend(selectedQuestion) });
    }
  };

  return (
    <StoryQuestion
      story={{ question: storyQuestion?.question || storyQuestionId, body: null }}
      fetching={fetching}
      storyQuestions={storyQuestions}
      disabled={isControlledModeStories && !!storyQuestionId}
      onSelectQuestion={handleOnSelectQuestion}
    />
  );
};

export default PromptSelector;
